"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.keyValuePairModel = void 0;
var keyValuePairModel = {
  name: {
    path: 'Name[0]',
    type: String
  },
  // While the type of all config values is variant, this library doesn't know or care about each individual
  // config value. Consumers of this library should convert to and from types as appropriate using an adapter.
  value: {
    path: 'Value[0]',
    type: String
  }
};
exports.keyValuePairModel = keyValuePairModel;


//////////////////
// WEBPACK FOOTER
// ./node_modules/lbs-pi-platform-access/es/data-server/security/config/models/kvp.js
// module id = 74
// module chunks = 0